import * as React from 'react';

interface IListingScrollContainerContextValue {
  scrollContainer: HTMLElement | null;
  setScrollContainer(element: HTMLElement | null): void;
}

/**
 * Связывает шторку со списком и тех, кто снаружи следит за её скроллом.
 */
export const ListingScrollContainerContext = React.createContext<IListingScrollContainerContextValue>({
  scrollContainer: null,
  setScrollContainer: () => undefined,
});

export const ListingScrollContainerProvider = ({ children }: { children: React.ReactNode }) => {
  const [scrollContainer, setScrollContainer] = React.useState<HTMLElement | null>(null);
  const value = React.useMemo(() => ({ scrollContainer, setScrollContainer }), [scrollContainer]);

  return <ListingScrollContainerContext.Provider value={value}>{children}</ListingScrollContainerContext.Provider>;
};

/** Контейнер, который скроллит список. Для тех, кто на этот скролл подписывается. */
export function useListingScrollContainer(): HTMLElement | null {
  return React.useContext(ListingScrollContainerContext).scrollContainer;
}

/** Ref-колбэк для шторки: ей остаётся повесить его на свой скроллящийся элемент. */
export function useSetListingScrollContainer(): (element: HTMLElement | null) => void {
  return React.useContext(ListingScrollContainerContext).setScrollContainer;
}
